import { render, staticRenderFns } from "./RelatedHelps.vue?vue&type=template&id=df758552"
import script from "./RelatedHelps.vue?vue&type=script&lang=js"
export * from "./RelatedHelps.vue?vue&type=script&lang=js"
import style0 from "./RelatedHelps.vue?vue&type=style&index=0&id=df758552&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports